<template>
  <div class="relateds" v-if="posts.length">
    <div class="label">
      {{ translate.labelRelated }}
    </div>
    <div class="row">
      <div
        v-for="(related, index) in posts"
        :key="index"
        class="card col-lg-4 col-6"
        style="background-color: white"
      >
        <NuxtLink
          v-if="related.content_type"
          :to="{
            name: 'language-blog-id-slug',
            params: {
              language: route.params.language,
              id: related.id,
              slug: related.slug,
            },
          }"
        >
          <div
            class="related-coluna"
            :style="`background-image: url(${related.cover});`"
          ></div>
          <h6 class="title">{{ related.title }}</h6>
        </NuxtLink>
        <a v-else :href="related.link_redirect" class="button--more">
          <div
            class="related-coluna"
            :style="`background-image: url(${related.cover});`"
          ></div>
          <h6 class="title">{{ related.title }}</h6>
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import translateMain from "@/tradutors/blogs";

const route = useRoute();

defineProps(["posts"]);
const translate = computed(() =>
  route.params.language === "pt-br"
    ? translateMain.portugues
    : translateMain.ingles
);
</script>
<style scoped>
.label {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  line-height: 28px;
  padding-inline: 0;
}
.title {
  font-family: "Roboto-Bold";
  font-size: 14px;
  letter-spacing: 0;
  color: #5b5858;
  margin-top: 10px;
}

.relateds {
  width: 808px;
  margin-top: 30px;
}

.related-coluna {
  margin-top: 10px;
}
.related-coluna {
  border-radius: 5px;
  box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px,
    rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;
  transition: transform 2s, filter 1.5s ease-in-out;
  transform-origin: center center;
  filter: brightness(100%);
  min-height: 10rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.related-coluna:hover {
  transform: scale(1.08);
  filter: brightness(70%);
  -moz-transition: all 300ms ease-in-out 0s;
  -webkit-transition: all 300ms ease-in-out 0s;
  -o-transition: all 300ms ease-in-out 0s;
  -ms-transition: all 300ms ease-in-out 0s;
  transition: all 300ms ease-in-out 0s;
}

@media screen and (max-width: 769px) {
  .related-coluna {
    min-height: 10rem;
  }
}

@media screen and (max-width: 500px) {
  .related-coluna {
    min-height: 7rem;
  }
}
</style>
